import { FONT_STYLES_SHEETS } from "@shared-constants/fonts";
import { ThemeConfigurationType } from "@shared-types/themes";

export const THEME_CONFIGURATIONS: ThemeConfigurationType = {
  DEFAULT: {
    BODY_BG: "bg-transparent",
    NAV: {
      bg: "bg-white",
      color: "text-slate01",
      weight: "font-semibold",
    },
    FOOTER_BG: "bg-black",
    FONT_FAMILY: "font-sans",
    STYLE_SHEETS: FONT_STYLES_SHEETS.OBVIOUSLY,
  },
  "02": {
    BODY_BG: "bg-sandstone01",
    NAV: {
      bg: "bg-sandstone01",
      color: "text-sapphire02",
      weight: "font-normal",
    },
    FOOTER_BG: "bg-sapphire01",
    FONT_FAMILY: "font-paralucent",
    STYLE_SHEETS: FONT_STYLES_SHEETS.PARLUCENT_CABRITO_OBVIOUSLY,
  },
};
